(() => {
  const FALLBACK_COMPONENTS = {
    '57416287945084': [
      { title: 'Calvin Klein Schwarze Polyester-Handtasche', quantity: 1 },
      { title: 'Calvin Klein Schwarze Damenbörse', quantity: 1 }
    ],
    '57416408498556': [
      { title: 'Coccinelle Schwarze Lederhandtasche', quantity: 1 },
      { title: 'Coccinelle Schwarzes Lederportemonnaie mit 5 Fächern', quantity: 1 }
    ],
    '57416408531324': [
      { title: 'Karl Lagerfeld Schwarze Crossbody-Tasche', quantity: 1 },
      { title: 'Karl Lagerfeld Schwarzes Portemonnaie mit Frontlogo', quantity: 1 }
    ],
    '57416408564092': [
      { title: 'Love Moschino Schwarze Handtasche', quantity: 1 },
      { title: 'Love Moschino Schwarzes Portemonnaie', quantity: 1 }
    ],
    '57416408596860': [
      { title: 'Vivienne Westwood Belle Heart Frame Handtasche', quantity: 1 },
      { title: 'Vivienne Westwood Schwarzes Kalbsleder-Portemonnaie', quantity: 1 }
    ],
    '57416408629628': [
      { title: 'Furla Poppy S Schwarze Handtasche aus Kalbsleder', quantity: 1 },
      { title: 'Furla Nero Leder Geldbörse für Damen', quantity: 1 }
    ],
    '57441130545532': [
      { title: 'Ganni Bou Pouch', quantity: 1 },
      { title: 'Ganni Bou Card Holder', quantity: 1 }
    ]
  };

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let syncTimer;
  let syncing = false;

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function labels() {
    const lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    if (lang === 'en') return { eyebrow: 'INCLUDED IN THE SET', head: '2 items in this set', foot: 'Added and purchased together as one set' };
    if (lang === 'it') return { eyebrow: 'INCLUSO NEL SET', head: '2 articoli in questo set', foot: 'Aggiunti e acquistati insieme come un unico set' };
    return { eyebrow: 'IM SET ENTHALTEN', head: '2 Artikel in diesem Set', foot: 'Werden gemeinsam als ein Set hinzugefügt und gekauft' };
  }

  function variantIdForRow(row) {
    const input = row.querySelector('[data-quantity-variant-id]');
    return input ? String(input.getAttribute('data-quantity-variant-id') || '') : '';
  }

  function componentsFromCartItem(cartItem, variantId) {
    if (cartItem && Array.isArray(cartItem.item_components) && cartItem.item_components.length) {
      return cartItem.item_components.map((component) => ({
        title: component.product_title || component.title || component.variant_title || '',
        quantity: component.quantity || 1
      })).filter((component) => component.title);
    }
    return FALLBACK_COMPONENTS[variantId] || [];
  }

  function renderSummary(row, components) {
    const copy = labels();
    let summary = row.querySelector('.arca-cart-bundle-summary');
    if (!components.length) {
      if (summary) summary.remove();
      row.classList.remove('arca-cart-bundle-parent');
      return;
    }

    const rows = components.map((component, index) =>
      `<li><span class="arca-cart-bundle-summary__index">${String(index + 1).padStart(2, '0')}</span><span class="arca-cart-bundle-summary__title">${escapeHtml(component.title)}</span><span class="arca-cart-bundle-summary__qty">× ${component.quantity}</span></li>`
    ).join('');

    const html = `<span class="arca-cart-bundle-summary__eyebrow">${copy.eyebrow}</span><strong class="arca-cart-bundle-summary__head">${copy.head}</strong><ul>${rows}</ul><span class="arca-cart-bundle-summary__foot">✓ ${copy.foot}</span>`;

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'arca-cart-bundle-summary';
      summary.setAttribute('data-arca-bundle-summary', '');
      const name = row.querySelector('.cart-item__name');
      if (name) name.insertAdjacentElement('afterend', summary);
    }
    if (summary && summary.innerHTML !== html) summary.innerHTML = html;
    row.classList.add('arca-cart-bundle-parent');
  }

  async function syncBundleCart() {
    if (syncing || !document.querySelector('.cart-item')) return;
    syncing = true;
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      const items = Array.isArray(cart.items) ? cart.items : [];
      document.querySelectorAll('.cart-item').forEach((row) => {
        const variantId = variantIdForRow(row);
        if (!variantId) return;
        const cartItem = items.find((item) => String(item.variant_id || item.id || '') === variantId);
        renderSummary(row, componentsFromCartItem(cartItem, variantId));
      });
    } catch (error) {
      console.warn('Arca Lucia bundle cart display:', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncBundleCart, 90);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  else scheduleSync();

  window.addEventListener('pageshow', scheduleSync);
  document.addEventListener('cart:updated', scheduleSync);
  const observer = new MutationObserver((mutations) => {
    const cartChanged = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => {
      if (node.nodeType !== 1) return false;
      return node.matches?.('.cart-item, cart-drawer, cart-items, cart-drawer-items') || node.querySelector?.('.cart-item');
    }));
    if (cartChanged) scheduleSync();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();